import { IconProps } from "./types";
import { cn } from "@punchup/utils/cn";

export default function FacebookIcon({
  className,
  width = 20,
  height = 20,
}: IconProps) {
  return (
    <svg
      viewBox="0 0 23 20"
      fill="currentColor"
      className={cn(
        "text-[#0766FF]", // Facebook blue
        className
      )}
      width={width}
      height={height}
    >
      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
    </svg>
  );
}
